(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[838],{

/***/ 23047:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/alternatives/docusign-alternatives",
      function () {
        return __webpack_require__(39198);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/alternatives-top.ff55cb9a.png","height":505,"width":1221,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAHlBMVEXY8/7T6/m237Whg3vJztLL4O6fnILD8tLA8Mu8ssFHKwIXAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGPgYGRgYGBhY2IAA05mKIORlR0AAqsAMVjz35oAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 46591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43138);
/* harmony import */ var _AppContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2208);
/* harmony import */ var _components_Cards_FeatureCards__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7041);
/* harmony import */ var _components_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46687);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10447);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56475);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69274);











const StickyLoginCard = (param)=>{
    let { pageProduct ="" , cardWidth ="xs:w-[360px]" , title , description  } = param;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_AppContext__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
    const content = {
        default: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating your own digital signature.",
            link: "https://sheetgod.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        approvals: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating your approval workflows.",
            link: "https://approval-dashboard.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        signature: {
            title: "Tired of nonsense pricing of DocuSign?",
            description: "Start taking digital signatures with BoloSign and save money.",
            link: "https://signature.boloforms.com/register?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        "timer-proctor": {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating tests using BoloForms Timer + Proctor.",
            link: "https://dashboard.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        sheetgod: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start enhancing your sheets using BoloForms SheetGod.",
            link: "https://sheetgod.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        taxes: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating your own digital signature.",
            link: "https://signature.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD").concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_8__/* .createUTMQueryParams */ .T0)({
                utmData_: context.globalData.utmData,
                from: "STICKY_CARD"
            }))
        }
    };
    const contentToDisplay = pageProduct && content[pageProduct] ? content[pageProduct] : content.signature;
    return(//   <div className="max-w-screen-mxl mx-auto">
    //   {
    //     <FeatureCards
    //       cardsData={featuresData}
    //       featuresStyling={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10`}
    //     />
    //   }
    //   <div className="mt-10 flex justify-center items-center">
    //     <ButtonPrimary buttonText={`All Features`} buttonUrl={`#`} />
    //   </div>
    // </div>
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full ".concat(cardWidth, " mx-auto border border-surface-dark  px-6 pt-7 pb-9 flex flex-col gap-4 text-center justify-center items-center rounded-xl bg-surface"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_4__.BASE_ASSETS_URL, "/boloforms-signature/boloforms-logo.png"),
                className: "w-auto h-auto rounded-full",
                width: 10,
                height: 10,
                alt: "BoloForms"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-2xl",
                        children: title ? title : contentToDisplay.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-gray-600",
                        children: description ? description : contentToDisplay.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: " flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_9__/* .CLMButtonPrimary */ .IS, {
                            buttonText: "Get started for free",
                            buttonUrl: contentToDisplay.link,
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_10__/* .HiArrowLongRight */ .P8b, {})
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (StickyLoginCard);


/***/ }),

/***/ 7041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const FeatureCards = (param)=>{
    let { cardsData , cardsStyling =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8",
        children: cardsData.map((card, index)=>{
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-6 border-2 px-6 sm:px-10 pb-10 pt-16 rounded-xl cardBorders transition-all duration-500 ease-in-out border-gray-600 text-center ".concat(card.styling),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-center w-[100px] h-[100px] mx-auto",
                        children: card.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-5xl lg:text-5xl flex justify-center items-center h-full w-full bg-white rounded-full",
                            children: card.icon
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-2xl font-bold",
                                children: card.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-xl",
                                children: card.description
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeatureCards);


/***/ }),

/***/ 39198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ docusign_alternatives; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./components/RandomCard/RandomCard.jsx



const RandomCard = (param)=>{
    let { icon , title , description , buttonText , buttonUrl  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full sm:w-[420px] shadow-lg p-12 border flex flex-col gap-4 text-center justify-center items-center rounded-2xl",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "bg-violet-400 text-violet-700 text-6xl p-8 rounded-full",
                children: icon
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "w-full flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "text-2xl",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-gray-600",
                        children: description
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        href: buttonUrl,
                        className: "w-full text-white bg-violet-600 py-3 px-8 rounded-full cursor-pointer font-semibold hover:opacity-90",
                        children: buttonText
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RandomCard_RandomCard = ((/* unused pure expression or super */ null && (RandomCard)));

// EXTERNAL MODULE: ./constants/signature.js
var signature = __webpack_require__(24599);
// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(43138);
// EXTERNAL MODULE: ./components/AppContext.js
var AppContext = __webpack_require__(2208);
// EXTERNAL MODULE: ./components/StickyLoginCard/index.jsx
var StickyLoginCard = __webpack_require__(46591);
;// CONCATENATED MODULE: ./pages/signature/alternatives/docusign-alternatives.jsx












const ListComponent = (param)=>{
    let { title , list  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-gray-900",
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-xl font-bold text-gray-900 mb-3",
                children: [
                    title,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "ml-10 list-disc text-lg",
                children: list.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "",
                            children: item
                        })
                    }, index))
            })
        ]
    });
};
const ParaGraphs = (param)=>{
    let { heading1 , heading2 , image , imageCaption , altText , paraList , list  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            heading1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-bold text-3xl text-black mb-4",
                children: heading1
            }),
            heading2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-bold text-xl text-gray-900",
                children: heading2
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                className: "relative w-full mb-5 sm:mb-6 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        width: "10",
                        height: "10",
                        className: "w-full h-auto object-cover border",
                        src: "".concat(constants.BASE_ASSETS_URL, "/v2/alternatives/").concat(image),
                        alt: altText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                        className: "text-center px-6 sm:px-10 text-xs sm:text-sm italic",
                        children: imageCaption
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "text-gray-900 flex flex-col gap-4 list-disc text-lg",
                children: [
                    paraList === null || paraList === void 0 ? void 0 : paraList.map((paragraph, index)=>typeof paragraph == "object" ? paragraph.map((para, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "text-black font-bold ml-10",
                                children: [
                                    para.li_head || para.ol_head,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-normal text-gray-900",
                                        children: para.li_desc || para.ol_desc
                                    })
                                ]
                            }, index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-gray-900",
                            children: paragraph
                        }, index)),
                    list && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListComponent, {
                        title: "",
                        list: list
                    })
                ]
            })
        ]
    });
};
const ComparisonTable = (param)=>{
    let { tableData  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full overflow-x-scroll sm:overflow-x-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mt-8 mb-6 text-gray-900",
                children: tableData === null || tableData === void 0 ? void 0 : tableData.heading2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-[500px] sm:w-full bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            children: tableData.headers.map((header, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "py-2 px-4 bg-gray-200 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider",
                                    children: header
                                }, index))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: tableData.rows.map((row, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: "text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "py-2 px-4 border-b border-r border-gray-200",
                                        children: row.feature
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "py-2 px-4 border-b border-r border-gray-200",
                                        children: row.boloSign
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "py-2 px-4 border-b border-r border-gray-200",
                                        children: row.docuSign
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "py-2 px-4 border-b border-r border-gray-200",
                                        children: row.otherCompetitors
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
};
const DocusignCompetitors = ()=>{
    const context = (0,react.useContext)(AppContext/* default */.Z);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full md:mt-20 mt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Top 10 DocuSign Alternatives in 2024: Best eSignature Solutions for Small Businesses"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Discover the best DocuSign alternatives in 2024, including BoloSign, offering affordable and feature-rich eSignature solutions for small businesses."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "Boloforms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "publisher",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "DocuSign Competitors, DocuSign Alternatives, DocuSign Competitors 2022, DocuSign Competitors 2023"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/alternatives/docusign-alternatives/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Top 10 DocuSign Alternatives in 2024: Best eSignature Solutions for Small Businesses"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/alternatives/docusign-alternatives/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "Top 10 DocuSign Alternatives in 2024: Best eSignature Solutions for Small Businesses"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/alternatives/docusign-alternatives/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-screen-xl md:px-8 px-4 mx-auto mb-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative w-full h-fit sm:h-[400px] lg:h-[500px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "w-full h-full sm:h-[400px] lg:h-[500px] object-cover rounded-3xl rounded-b-3xl",
                                    src: __webpack_require__(54415),
                                    width: 10,
                                    height: 10,
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative lg:absolute md:left-8 md:bottom-8 left-0 bottom-0 bg-white z-1000 py-8 lg:pl-10 lg:pr-24 rounded-3xl",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "mx-auto text-violet-600 font-semibold uppercase text-lg",
                                            children: "APPS"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "text-black text-4xl",
                                            children: "Top 10 DocuSign Alternatives in 2024"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center gap-5 mt-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-[70px] h-[70px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "".concat(constants.BASE_ASSETS_URL, "/about/paresh.png"),
                                                        width: "10",
                                                        height: "10",
                                                        className: "w-full h-full object-cover rounded-full",
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "font-bold text-xl text-black",
                                                            children: "Paresh Deshmukh"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-gray-800",
                                                            children: "Last updated on August 10, 2023"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col lg:flex-row-reverse justify-between mt-[50px] sm:mt-[350px] lg:mt-[100px] lg:gap-12 xxl:gap-40",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "self-center lg:self-start lg:sticky lg:top-[140px] flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyLoginCard/* default */.Z, {
                                    cardWidth: "xs:w-[370px]",
                                    title: "Create a free BoloForms account today!",
                                    description: "Create your free account today and start creating your own digital signature."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-col gap-10 mt-10 lg:mt-6 text-lg text-gray-900",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "",
                                            children: "Are you looking for DocuSign alternatives that offer great\n                features at a more affordable price? You're in the right place!\n                In this comprehensive guide, we'll explore the top 10\n                DocuSign competitors, with a special focus on BoloSign - an\n                excellent DocuSign alternative that's perfect for small\n                businesses."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-col gap-6 mt-10",
                                        children: signature/* docusignData.map */.Or.map((item, index)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ParaGraphs, {
                                                heading1: item === null || item === void 0 ? void 0 : item.heading1,
                                                heading2: item === null || item === void 0 ? void 0 : item.heading2,
                                                image: item === null || item === void 0 ? void 0 : item.image,
                                                imageCaption: item === null || item === void 0 ? void 0 : item.imageCaption,
                                                altText: item === null || item === void 0 ? void 0 : item.altText,
                                                paraList: item === null || item === void 0 ? void 0 : item.paragraphs,
                                                list: item === null || item === void 0 ? void 0 : item.listData
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full flex flex-col gap-20 mt-10",
                                        children: signature/* alternatives.map */.uw.map((item, index)=>{
                                            var _item_paragraphs2;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                className: "w-full flex items-center gap-5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "w-full flex flex-col gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "font-bold text-2xl text-gray-800",
                                                            children: [
                                                                item.id,
                                                                ". ",
                                                                item.alternative_title
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                                            className: "relative w-full mb-5 sm:mb-6 flex flex-col gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "".concat(constants.BASE_ASSETS_URL, "/v2/alternatives/").concat(item.image),
                                                                    width: "10",
                                                                    height: "10",
                                                                    className: "w-full h-auto object-cover border",
                                                                    alt: item === null || item === void 0 ? void 0 : item.altText
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                                                    className: "text-center px-6 sm:px-10 text-xs sm:text-sm italic",
                                                                    children: item === null || item === void 0 ? void 0 : item.imageCaption
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            className: "text-gray-900 flex flex-col gap-4 list-disc text-lg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParaGraphs, {
                                                                paraList: item.paragraphs
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListComponent, {
                                                            title: "Key Features",
                                                            list: item.key_features
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListComponent, {
                                                            title: "Integrations",
                                                            list: item.integrations
                                                        }),
                                                        (item === null || item === void 0 ? void 0 : item.pricing) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListComponent, {
                                                            title: "Pricing",
                                                            list: item.pricing
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListComponent, {
                                                            title: "Pros",
                                                            list: item.pros
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListComponent, {
                                                            title: "Cons",
                                                            list: item.cons
                                                        }),
                                                        (item === null || item === void 0 ? void 0 : item.tableData) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonTable, {
                                                            tableData: item === null || item === void 0 ? void 0 : item.tableData
                                                        }),
                                                        (item === null || item === void 0 ? void 0 : item.paragraphs2) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListComponent, {
                                                            title: (_item_paragraphs2 = item.paragraphs2) === null || _item_paragraphs2 === void 0 ? void 0 : _item_paragraphs2.title,
                                                            list: item.paragraphs2.paras
                                                        })
                                                    ]
                                                })
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full flex flex-col gap-6 mt-10",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParaGraphs, {
                                                heading1: signature/* alternativeConclusion.heading1 */.dH.heading1,
                                                paraList: signature/* alternativeConclusion.paragraphs */.dH.paragraphs
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var docusign_alternatives = (DocusignCompetitors);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4599,9774,2888,179], function() { return __webpack_exec__(23047); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);